module.exports = __webpack_public_path__ + "img/shopping_cart.d91abf6d.png";